import React, { useEffect } from 'react';
import RedesContacto from './RedesContacto';
export default function VulneracionHomicidio({ 
    register, 
    watch, 
    setValue, 
    getValues,
    append, 
    remove,
    parentescos = [], 
    errors = {}, 
    useAuth, 
    apiService, 
    Cargando, 
    setCargando, 
    idCabezaFamilia, 
    user, 
    token, 
    Mensaje, 
	paises = [],
	barrios = [],
    municipiosdto = [],
    tiposDocumentos = []
}) {
    const [mediosHomicidio, setMediosHomicidio] = React.useState([]);
    const [modalidadesHomicidio, setModalidadesHomicidio] = React.useState([]);
    const [presuntosVictimizarios, setPresuntosVictimizarios] = React.useState([]);
    const ObtenerDatosSelects = async () => {
        let url = `/ddhh/vulneraciones/obtenerdatosselectshomicidio`;
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            setMediosHomicidio(result.MediosHomicidio);
            setPresuntosVictimizarios(result.PresuntosVictimizarios);
            setModalidadesHomicidio(result.ModalidadesHomicidio);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    useEffect(() => {
        ObtenerDatosSelects();
    }, []);
    const modalidadSeleccionada = watch ? watch('datosVulneracion.intIdmodalidadHomicidio') : '';
    useEffect(() => {
        if (modalidadesHomicidio.length === 0) {
            return;
        }

        const modalidadSeleccionadaId =
            modalidadSeleccionada && typeof modalidadSeleccionada === 'object'
                ? (modalidadSeleccionada.id ?? modalidadSeleccionada.value ?? '')
                : modalidadSeleccionada;

        if (!modalidadSeleccionadaId) {
            return;
        }

        setValue('datosVulneracion.intIdmodalidadHomicidio', String(modalidadSeleccionadaId), {
                shouldValidate: true,
                shouldDirty: false,
        });
    }, [modalidadesHomicidio, modalidadSeleccionada, setValue]);
    const medioSeleccionado = watch ? watch('datosVulneracion.intIdmedio') : '';
    useEffect(() => {
        if (mediosHomicidio.length === 0 || !medioSeleccionado) {
            return;
        }

        setValue('datosVulneracion.intIdmedio', String(medioSeleccionado), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [mediosHomicidio, medioSeleccionado, setValue]);
    const presuntoVictimizarioSeleccionado = watch ? watch('datosVulneracion.intIdpresuntoVictimizario') : '';
    useEffect(() => {
        if (presuntosVictimizarios.length === 0 || !presuntoVictimizarioSeleccionado) {
            return;
        }

        setValue('datosVulneracion.intIdpresuntoVictimizario', String(presuntoVictimizarioSeleccionado), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [presuntosVictimizarios, presuntoVictimizarioSeleccionado, setValue]);
    return (
        <div className="card">
            <div className="card-header">
                <div className="col-sm-12">
                    <h6 className="text-primary font-weight-bold mb-3">Datos del Homicidio</h6>
                </div>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="datosVulneracion.strRadicadoSpoa">Radicado SPOA</label>
                            <input
                                id="datosVulneracion.strRadicadoSpoa"
                                type="text"
                                className="form-control"
                                {...register('datosVulneracion.strRadicadoSpoa', { required: true })}
                            />
                            {errors.datosVulneracion?.strRadicadoSpoa && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="datosVulneracion.intIdmodalidadHomicidio">Modalidad homicidio</label>
                            <select
                                id="datosVulneracion.intIdmodalidadHomicidio"
                                className="form-control"
                                {...register('datosVulneracion.intIdmodalidadHomicidio', { required: true })}
                            >
                                <option value="">Seleccione...</option>
                                {modalidadesHomicidio.map((option, idx) => (
                                    <option key={option.id} value={option.id}>
                                        {option.str_nombre}
                                    </option>
                                ))}
                            </select>
                            {errors.datosVulneracion?.intIdmodalidadHomicidio && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="datosVulneracion.intIdmedio">Medios</label>
                            <select
                                id="datosVulneracion.intIdmedio"
                                className="form-control"
                                {...register('datosVulneracion.intIdmedio', { valueAsNumber: true, required: true })}
                            >
                                <option value="">Seleccione...</option>
                                {mediosHomicidio.map((option, idx) => (
                                    <option key={option.id} value={option.id}>
                                        {option.str_nombre}
                                    </option>
                                ))}
                            </select>
                            {errors.datosVulneracion?.intIdmedio && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="datosVulneracion.intIdpresuntoVictimizario">Presunto victimizario</label>
                            <select
                                id="datosVulneracion.intIdpresuntoVictimizario"
                                className="form-control"
                                {...register('datosVulneracion.intIdpresuntoVictimizario', { valueAsNumber: true, required: true })}
                            >
                                <option value="">Seleccione...</option>
                                {presuntosVictimizarios.map((option, idx) => (
                                    <option key={option.id} value={option.id}>
                                        {option.str_nombre}
                                    </option>
                                ))}
                            </select>
                            {errors.datosVulneracion?.intIdpresuntoVictimizario && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <label htmlFor="datosVulneracion.strNroAsignadoFiscalia">Informaci&oacute;n de unidad de la fiscal&iacute;a (LOCAL, SECCIONAL, ESPECIALIZADA, UNIDAD DE VIDA)</label>
                            <textarea
                                rows="3"
                                id="datosVulneracion.strNroAsignadoFiscalia"
                                className="form-control"
                                {...register('datosVulneracion.strNroAsignadoFiscalia', { required: true })}
                            />
                            {errors.datosVulneracion?.strNroAsignadoFiscalia && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="datosVulneracion.strFueronALugarHecho">¿fueron o no al lugar del hecho?</label>
                            <select id="datosVulneracion.strFueronALugarHecho" className="form-control" {...register('datosVulneracion.strFueronALugarHecho' , { required: true })}>
                                <option value="">Seleccione...</option>
                                <option value="SI">SI</option>
                                <option value="NO">NO</option>
                            </select>
                            {errors.datosVulneracion?.strFueronALugarHecho && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label htmlFor="datosVulneracion.strCti">CTI/policia judicial</label>
                            <select id="datosVulneracion.strCti" className="form-control" {...register('datosVulneracion.strCti' , { required: true })}>
                                <option value="">Seleccione...</option>
                                <option value="SI">SI</option>
                                <option value="NO">NO</option>
                            </select>
                            {errors.datosVulneracion?.strCti && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="datosVulneracion.strMedicinaLegal">Medicina legal</label>
                            <select id="datosVulneracion.strMedicinaLegal" className="form-control" {...register('datosVulneracion.strMedicinaLegal' , { required: true })}>
                                <option value="">Seleccione...</option>
                                <option value="SI">SI</option>
                                <option value="NO">NO</option>
                            </select>
                            {errors.datosVulneracion?.strMedicinaLegal && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="datosVulneracion.strFiscaliaGnral">Fiscal&iacute;a general de la naci&oacute;n</label>
                            <select id="datosVulneracion.strFiscaliaGnral" className="form-control" {...register('datosVulneracion.strFiscaliaGnral', { required: true })}>
                                <option value="">Seleccione...</option>
                                <option value="SI">SI</option>
                                <option value="NO">NO</option>
                            </select>
                            {errors.datosVulneracion?.strFiscaliaGnral && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="datosVulneracion.strExcequias">Fue atendido por las exequ&iacute;as del jard&iacute;n cementerio universal</label>
                            <select id="datosVulneracion.strExcequias" className="form-control" {...register('datosVulneracion.strExcequias')}>
                                <option value="">Seleccione...</option>
                                <option value="SI">SI</option>
                                <option value="NO">NO</option>
                            </select>
                            {errors.datosVulneracion?.strExcequias && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className='row'>
                            <div className="col-md-12">
                                <label htmlFor="datosVulneracion.strContextosocialindividual">Contexto Individual y Social</label>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-md-12">
                            <textarea rows={3} style={{ width: '100%' }}
                                {...register('datosVulneracion.strContextosocialindividual', { required: true })}
                                placeholder="Contexto Individual y Social"
                            />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className='row'>
                            <div className="col-md-12">
                                <label htmlFor="datosVulneracion.strComposicionfamiliar">Composici&oacute;n Familiar</label>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-md-12">
                            <textarea rows={3} style={{ width: '100%' }}
                                {...register('datosVulneracion.strComposicionfamiliar', { required: true })}
                                placeholder="Composición Familiar"
                            />
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
                <RedesContacto
                    register={register}
                    getValues={getValues}
                    watch={watch}
                    append={append}
                    remove={remove}
                    errors={errors}
                    paises={paises}
                    barrios={barrios}
                    municipiosdto={municipiosdto}
                    parentescos={parentescos}
                    tiposDocumentos={tiposDocumentos}
                />
                <hr />
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="datosVulneracion.strProfesionalAtencion">Profesional atencion</label>
                            <input readOnly
                                id="datosVulneracion.strProfesionalAtencion"
                                type="text"
                                className="form-control"
                                {...register('datosVulneracion.strProfesionalAtencion', { required: true })}
                            />
                            {errors.datosVulneracion?.strProfesionalAtencion && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <input type="hidden" {...register('datosVulneracion.intVulneracionDerechosId', { valueAsNumber: true })} />
                    </div>
                </div>
            </div>
        </div>
    );
}
